import anime from 'animejs'
import { DEFAULT_INITIAL_SETTINGS } from '../constants/initial-settings'
import { onSelect, onSelectAll } from '../utils/dom'
import { onAdd, onRemove } from '../utils/class-list'

class Counter {
  constructor(params) {
    this.counter = params.counter
    this.intervalUpdated = params.intervalUpdated

    this.init()
  }

  init() {
    if (this.counter === null) return null
    this.numCounter = Number(this.getNumCounter())
    this.onIncrementDigits()
    this.onAnimationEnd()
  }

  getNumCounter() {
    return this.counter.getAttribute('data-js-counter')
  }

  setNumCounter() {
    this.numCounter = this.numCounter + 1
    this.counter.setAttribute('data-js-counter', this.numCounter)
  }

  onPad(num, size) {
    let s = num + ''
    while (s.length < size) s = '0' + s
    return s
  }

  onIncrementDigits() {
    setInterval(() => {
      this.setNumCounter()
      this.onFlipDigits()
    }, this.intervalUpdated)
  }

  onAnimationEnd() {
    let digist = onSelectAll('.digit', this.counter)

    digist.forEach((digit) => {
      let current = onSelect('span', digit)

      current.addEventListener(
        'animationend',
        () => {
          onRemove(current.parentNode, 'flip')
        },
        false
      )
    })
  }

  onFlipDigits() {
    let digist = onSelectAll('.digit', this.counter)

    this.setNewDigits(digist, this.numCounter)
    this.onAnimateDigits(digist)
  }

  setNewDigits(digist, num) {
    let chars = this.onPad(num, digist.length)

    digist.forEach((digit, index) => {
      let current = onSelect('span', digit)

      digit.setAttribute('data-js-count-from', current.textContent)
      digit.setAttribute('data-js-count-to', chars[index])

      current.setAttribute('data-js-count-from', current.textContent)
      current.setAttribute('data-js-count-to', chars[index])

      current.textContent = chars[index]
    })
  }

  onAnimateDigits(digist) {
    digist.forEach((digit) => {
      let current = onSelect('span', digit)

      if (digit.getAttribute('data-js-count-from') !== current.textContent) onAdd(digit, 'flip')
    })
  }
}

window.addEventListener('load', () => {
  const numberCounter = new Counter({
    counter: onSelect('#_6etih86kf [data-js-counter]'),
    intervalUpdated: 2400,
  })
})
